function errorMessage(error: unknown): string {
  if (error instanceof Error) {
    return error.message
  }
  return String(error ?? '')
}

const SW_UPDATE_ERROR_PATTERN = /failed to update a serviceworker for scope/i

/**
 * The browser's own periodic/automatic ServiceWorker update check (independent of any
 * app-level `registration.update()` call — see PwaUpdateBanner.vue, which already catches
 * its own explicit calls) rejects with this message when it races a deploy rollover or a
 * flaky connection. It has no call site the app can attach a `.catch()` to, so it always
 * surfaces via the global `unhandledrejection` handler instead.
 */
export function isServiceWorkerUpdateError(error: unknown): boolean {
  return SW_UPDATE_ERROR_PATTERN.test(errorMessage(error))
}
